import { fetchUrlAsFile } from './fetchUrlAsFile';
import { postToHost } from './postToHost';

const CONCURRENCY = 6;

export type FetchError = { url: string; message: string };

export type FetchAllResult = {
    files: File[];
    errors: FetchError[];
};

export const fetchAllAsFiles = async (urls: string[]): Promise<FetchAllResult> => {
    const files: File[] = [];
    const errors: FetchError[] = [];
    let cursor = 0;
    let done = 0;
    const total = urls.length;

    const worker = async () => {
        while (true) {
            const index = cursor++;
            if (index >= total) {
                return;
            }
            const url = urls[index];
            try {
                const file = await fetchUrlAsFile(url);
                files.push(file);
            } catch (e: any) {
                const message = e?.message ?? String(e);
                errors.push({ url, message });
                postToHost({ type: 'addUserImages:error', url, message });
            } finally {
                done += 1;
                postToHost({ type: 'addUserImages:progress', done, total });
            }
        }
    };

    const workers: Promise<void>[] = [];
    const workerCount = Math.min(CONCURRENCY, Math.max(1, total));
    for (let i = 0; i < workerCount; i++) {
        workers.push(worker());
    }
    await Promise.all(workers);

    return { files, errors };
};